import { FloatingActionButton, PhoneIcon24 } from '@landsbankinn/ui-kit';
import { useRef, useState } from 'react';

export function MockAuthenticator({ debugUrl }: { debugUrl: string }) {
  const [showLabel, setShowLabel] = useState<boolean>(true);
  /*
   * What's up with this scroll panel with dummy elements?
   *
   * `FloatingActionButton` doesn't expose a programmatic way to show and hide
   * its label. However, it does have built-in behavior that activates and
   * deactivates the label based on the scroll position of a scrollable
   * element. So when the icon is clicked we simulate a full scroll to the
   * bottom or to the top (toggled by the current position), letting the
   * `FloatingActionButton` do its natural thing.
   */
  const scrollRef = useRef<HTMLDivElement>(null);

  const handleDotsClick = () => {
    const el = scrollRef.current;
    if (el) {
      el.scrollTo({
        top: showLabel ? el.scrollHeight : 0,
        behavior: 'smooth',
      });
    }
    setShowLabel(!showLabel);
  };

  return (
    <>
      <div
        ref={scrollRef}
        style={{ visibility: 'hidden', height: 320, overflowY: 'auto' }}
      >
        {Array.from({ length: 50 }, (_, i) => (
          <p key={i}>scroll</p>
        ))}
      </div>
      <FloatingActionButton
        scrollingElement={scrollRef}
        icon={<PhoneIcon24 color="white font" size="30" />}
        getLabel={() => 'Mock authenticate'}
        onLabelClick={() => window.open(debugUrl, '_blank')}
        onDotsClick={handleDotsClick}
      />
    </>
  );
}
